import React, {Component} from 'react';
import TextTruncate from 'react-text-truncate';
import LocalizedStrings from '../../localization/strings';
import { ContentState, EditorState, convertFromHTML, convertToRaw } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import draftToHtml from 'draftjs-to-html';


const strip = (html) => {
    var tmp = document.createElement('DIV');
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || '';
}

export default class TextField extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editing: false,
            editorState: null
        };
    }


    onChange(editorState){
        const rawContentState = convertToRaw(editorState.getCurrentContent());
        this.setState({  editorState });
        this.props.onChange(draftToHtml(  rawContentState ));
    }

    render() {
        let {value} = this.props;
        if (this.state.editing) {
            return <Editor  editorState={this.state.editorState}  onEditorStateChange={this.onChange.bind(this)}  />;
        } else {
            return (
                <div className="text-field">
                    <a className="btn" onClick={() => {
                        const blocksFromHTML = convertFromHTML(this.props.value || '');
                        const contentState = ContentState.createFromBlockArray(
                            blocksFromHTML.contentBlocks,
                            blocksFromHTML.entityMap
                        );

                        this.setState({editing: true, editorState: EditorState.createWithContent(contentState)})
                    }}>{LocalizedStrings.edit}</a>
                    <TextTruncate line={10} truncateText="…" text={strip(value)}/>

                </div>
            )
        }

    }
}



// WEBPACK FOOTER //
// ./src/js/components/form/text-field.js